// extracted by mini-css-extract-plugin
export default {"wrap":"Select_wrap__NF-I+","wrap__label":"Select_wrap__label__vxqhv","wrap__select":"Select_wrap__select__FQA-K"};